module.exports = __webpack_public_path__ + "img/special_moisturegel_202403.f29b306b.jpg";